import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export default function usePlayerStatistics() {
  const { details } = useSelector(state => state.reports.slotsHistory);

  const data = useMemo(() => {
    const { format } = new Intl.NumberFormat('de', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });

    return {
      totalBetCount: details.totalBetCount,
      totalBet: format(details.totalBet),
      totalWon: format(details.totalWon),
      netwin: format(details.totalIncome),
    };
  }, [details]);

  return data;
}
